import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateLeadFormPage } from 'src/app/pages/global/create-lead-form/create-lead-form.page';

const routes: Routes = [
  {
    path: '',
    component: CreateLeadFormPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateLeadPageRoutingModule {
}
